var path = '/templates/projects.segments/campaign_segment_show_all.html';
var html = "<div class=row></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.segments/campaign_segment_show_all.html
// module id = 1490
// module chunks = 0